import React, { useEffect } from "react";
import { ITelemetryClient } from "sonobello.utilities.react.telemetry";

import { TelemetrySessionTags } from "../../../../Telemetry/types/ITelemetryClient";
import { UserEventType } from "../../../types/IUserEvent";
import IHeatmappingClient from "../../types/IHeatmappingClient";
import IUserEventConsumerProps from "../../types/IUserEventConsumerProps";
import IGoogleTagsManagerEventFactory from "./GoogleTagsManagerEventFactory";

export interface IGoogleTagsUserEventConsumerConfig {
  eventFactory: IGoogleTagsManagerEventFactory;
  heatmappingClient: IHeatmappingClient;
  rules: Partial<Record<UserEventType, (event: unknown) => boolean>>;
  telemetryClient: ITelemetryClient<TelemetrySessionTags>;
}

const GoogleTagsUserEventConsumer: React.FC<IGoogleTagsUserEventConsumerConfig & IUserEventConsumerProps> = ({
  eventFactory,
  heatmappingClient,
  rules,
  telemetryClient,
  userEvent
}) => {
  useEffect(() => {
    if (!userEvent) return;

    const eventRule = rules[userEvent.type];

    if (eventRule && !eventRule(userEvent)) return;

    const event = eventFactory.buildEvent(userEvent);

    if (!event) {
      telemetryClient.traceException(
        new Error(`No Google Tags event name mapped for user event type: ${UserEventType[userEvent.type]}`)
      );
      return;
    }
    try {
      heatmappingClient.pushEvent(event);
    } catch (error) {
      telemetryClient.traceException(error as Error);
    }
  }, [userEvent]);

  return null;
};

export default GoogleTagsUserEventConsumer;
